import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import type { Review } from '../../models/review.model';

@Component({
  selector: 'ess-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ReviewComponent {
  @Input() review: Review | undefined;
}
